import { Label, Message } from 'semantic-ui-react';
import { getChannelOption } from './helper';
import React from 'react';

export function normalizeNumeric(value) {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === 'string') {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function renderText(text, limit) {
  if (text.length > limit) {
    return text.slice(0, limit - 3) + '...';
  }
  return text;
}

export function renderGroup(group) {
  if (group === '') {
    return <Label>default</Label>;
  }
  let groups = group.split(',');
  groups.sort();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '2px',
        rowGap: '6px',
      }}
    >
      {groups.map((group) => {
        if (group === 'vip' || group === 'pro') {
          return <Label color='yellow'>{group}</Label>;
        } else if (group === 'svip' || group === 'premium') {
          return <Label color='red'>{group}</Label>;
        }
        return <Label>{group}</Label>;
      })}
    </div>
  );
}

export function renderNumber(num) {
  const numeric = normalizeNumeric(num);
  if (numeric === null) {
    return num;
  }
  if (numeric >= 1000000000) {
    return (numeric / 1000000000).toFixed(1) + 'B';
  } else if (numeric >= 1000000) {
    return (numeric / 1000000).toFixed(1) + 'M';
  } else if (numeric >= 10000) {
    return (numeric / 1000).toFixed(1) + 'k';
  } else {
    return numeric;
  }
}

export function renderQuota(quota, t, precision = 2, channelName = '') {
  const numericQuota = normalizeNumeric(quota);
  if (numericQuota === null) {
    return quota;
  }
  const displayInCurrency =
    localStorage.getItem('display_in_currency') === 'true';
  const quotaPerUnit = parseFloat(
    localStorage.getItem('quota_per_unit') || '1'
  );

  // AgentsFlare渠道使用美元显示
  if (channelName === 'AgentsFlare') {
    const usdQuotaPerUnit = 500000; // $0.002 / 1K tokens
    const amount = (numericQuota / usdQuotaPerUnit).toFixed(precision);
    return `$${amount}`;
  }

  if (displayInCurrency) {
    const amount = (numericQuota / quotaPerUnit).toFixed(precision);
    return t('common.quota.display_short', { amount });
  }

  return renderNumber(numericQuota);
}

export function renderQuotaWithPrompt(quota, t) {
  const numericQuota = normalizeNumeric(quota);
  if (numericQuota === null) {
    return '';
  }
  const displayInCurrency =
    localStorage.getItem('display_in_currency') === 'true';
  const quotaPerUnit = parseFloat(
    localStorage.getItem('quota_per_unit') || '1'
  );

  if (displayInCurrency) {
    const amount = (numericQuota / quotaPerUnit).toFixed(2);
    return ` (${t('common.quota.display', { amount })})`;
  }

  return '';
}

const colors = [
  'red',
  'orange',
  'yellow',
  'olive',
  'green',
  'teal',
  'blue',
  'violet',
  'purple',
  'pink',
  'brown',
  'grey',
  'black',
];

export function renderColorLabel(text) {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }
  let index = Math.abs(hash % colors.length);
  return (
    <Label basic color={colors[index]}>
      {text}
    </Label>
  );
}

export function renderChannelTip(channelId) {
  let channel = getChannelOption(channelId);
  if (channel === undefined || channel.tip === undefined) {
    return <></>;
  }
  return (
    <Message>
      <div dangerouslySetInnerHTML={{ __html: channel.tip }}></div>
    </Message>
  );
}

// 双币种余额显示函数
export function renderBalance(balanceUSD, balanceCNY, precision = 4) {
  if (balanceUSD === undefined && balanceCNY === undefined) {
    return '¥0.00 / $0.0000';
  }

  const normalizedUSD = normalizeNumeric(balanceUSD);
  const normalizedCNY = normalizeNumeric(balanceCNY);
  const usd = normalizedUSD !== null ? normalizedUSD.toFixed(precision) : '0.0000';
  const cny = normalizedCNY !== null ? normalizedCNY.toFixed(2) : '0.00';

  return `¥${cny} / $${usd}`;
}

// 单独显示USD
export function renderUSD(amount, precision = 4) {
  const numeric = normalizeNumeric(amount);
  if (numeric === null) {
    return '$0.0000';
  }
  return `$${numeric.toFixed(precision)}`;
}

// 单独显示CNY
export function renderCNY(amount, precision = 2) {
  const numeric = normalizeNumeric(amount);
  if (numeric === null) {
    return '¥0.00';
  }
  return `¥${numeric.toFixed(precision)}`;
}
